<div class='h-100'>
    <svg class="icon-20 fill-iconDefault cursor-pointer" (click)="openSearchWindow()"><use href="../App_Themes/CXone/icons/new-window.svg#new-window"></use></svg>
</div>
